import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import { TbPlant2 } from "react-icons/tb";
import "./FlowersCall.css";

export default function FlowersCall(props) {
  return (
    <Container className="flowers-section">
      <Row>
        <Col className="flowers-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <TbPlant2
              style={{ color: props.iconColor }}
              className="flowers-icon"
            />
            FLORES E COROAS
          </h2>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="flowers-third-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Faça por aqui seu pedido de coroas, arranjos e vasos. <br />
            Horário de atendimento: diariamente das 8h às 18h.
          </p>
          <CustomButton
            className="primary-btn"
            variant="primary"
            href={`https://wa.me/${props.whatsAppFloricultura}`}
            rel="noopener noreferrer"
            target="_blank"
            icon=""
            content="FALE COM A FLORICULTURA"
            backgroundColor={props.primaryBtnColor}
            fontFamily="Unageo-Bold"
            fontColor={props.white}
            fontSize={18}
            width={290}
            borderColor={props.primaryBtnColor}
            disabled={false}
          />
        </Col>
        <Col lg={{ span: 6, order: "first" }} className="flowers-second-col">
          <div className="flowers-img-container">
            <img src={props.flowerImage} alt="Flores e coroas" />
            <div className="flowers-img-overlay" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
